
// Generated from  DocumentManagement.cs

import { ApiRequestAsync } from "./ApiRequest";
import { Promise } from 'es6-promise';
import { InputType, InputText, InputNumber, InputBoolean, InputChoice, InputFile, InputDate, PrivilegeMembership, FileNote, LanguageInfo, RemoveQuery, FilterMode, ValueCaptionPair } from "./Shared";


export function getDocumentAsync(query: DocumentDetailsQuery): Promise<DocumentDetails> {
	return ApiRequestAsync<DocumentDetails>('IDocumentManagementApi', 'GetDocumentAsync', query);
}

export function getNewDocumentMetaAsync(metaId: string): Promise<DocumentMeta> {
	return ApiRequestAsync<DocumentMeta>('IDocumentManagementApi', 'GetNewDocumentMetaAsync', metaId);
}

export function getNewDocumentMetasAsync(query: NewDocumentMetasQuery): Promise<DocumentMeta[]> {
	return ApiRequestAsync<DocumentMeta[]>('IDocumentManagementApi', 'GetNewDocumentMetasAsync', query);
}

export function getNewChildCollectionAsync(parentId: string): Promise<CollectionDetails> {
	return ApiRequestAsync<CollectionDetails>('IDocumentManagementApi', 'GetNewChildCollectionAsync', parentId);
}

export function insertOrUpdateDocumentAsync(update: DocumentDetailsUpdate): Promise<DocumentDetails> {
	return ApiRequestAsync<DocumentDetails>('IDocumentManagementApi', 'InsertOrUpdateDocumentAsync', update);
}

export function getDocumentFilesAsync(documentId: string): Promise<DocumentFiles> {
	return ApiRequestAsync<DocumentFiles>('IDocumentManagementApi', 'GetDocumentFilesAsync', documentId);
}

export function updateDocumentFilesAsync(update: DocumentFilesUpdate): Promise<DocumentFiles> {
	return ApiRequestAsync<DocumentFiles>('IDocumentManagementApi', 'UpdateDocumentFilesAsync', update);
}

export function removeDocumentAsync(query: RemoveQuery): Promise<void> {
	return ApiRequestAsync<void>('IDocumentManagementApi', 'RemoveDocumentAsync', query);
}

export function removeDocumentsAsync(query: RemoveQuery[]): Promise<void> {
	return ApiRequestAsync<void>('IDocumentManagementApi', 'RemoveDocumentsAsync', query);
}

export function queryCollectionCountAsync(searchTerm: string): Promise<number> {
	return ApiRequestAsync<number>('IDocumentManagementApi', 'QueryCollectionCountAsync', searchTerm);
}

export function queryNextCollectionAsync(query: CollectionsQuery): Promise<string[]> {
	return ApiRequestAsync<string[]>('IDocumentManagementApi', 'QueryNextCollectionAsync', query);
}

export function queryPreviousCollectionAsync(query: CollectionsQuery): Promise<string[]> {
	return ApiRequestAsync<string[]>('IDocumentManagementApi', 'QueryPreviousCollectionAsync', query);
}

export function queryCollectionDocumentsAsync(query: CollectionDocumentQuery): Promise<DocumentInfo[]> {
	return ApiRequestAsync<DocumentInfo[]>('IDocumentManagementApi', 'QueryCollectionDocumentsAsync', query);
}

export function getCollectionHierarchyAsync(collectionId: string): Promise<CollectionHierarchy> {
	return ApiRequestAsync<CollectionHierarchy>('IDocumentManagementApi', 'GetCollectionHierarchyAsync', collectionId);
}

export function getSubCollectionsAsync(collectionId: string): Promise<CollectionInfo[]> {
	return ApiRequestAsync<CollectionInfo[]>('IDocumentManagementApi', 'GetSubCollectionsAsync', collectionId);
}

export function getCollectionAsync(collectionId: string): Promise<CollectionDetails> {
	return ApiRequestAsync<CollectionDetails>('IDocumentManagementApi', 'GetCollectionAsync', collectionId);
}

export function insertOrUpdateCollectionAsync(update: CollectionDetailsUpdate): Promise<CollectionDetails> {
	return ApiRequestAsync<CollectionDetails>('IDocumentManagementApi', 'InsertOrUpdateCollectionAsync', update);
}

export function removeCollectionAsync(query: RemoveQuery): Promise<void> {
	return ApiRequestAsync<void>('IDocumentManagementApi', 'RemoveCollectionAsync', query);
}

export function removeCollectionsAsync(queries: RemoveQuery[]): Promise<void> {
	return ApiRequestAsync<void>('IDocumentManagementApi', 'RemoveCollectionsAsync', queries);
}

export function moveDocumentsToCollectionAsync(documentsToAdd: CollectionContentUpdate): Promise<void> {
	return ApiRequestAsync<void>('IDocumentManagementApi', 'MoveDocumentsToCollectionAsync', documentsToAdd);
}

export function moveCollectionsToCollectionAsync(collectionsToAdd: CollectionContentUpdate): Promise<void> {
	return ApiRequestAsync<void>('IDocumentManagementApi', 'MoveCollectionsToCollectionAsync', collectionsToAdd);
}

export function queryCollectionPrivilegeInfosAsync(query: CollectionPrivilegesQuery): Promise<CollectionPrivileges> {
	return ApiRequestAsync<CollectionPrivileges>('IDocumentManagementApi', 'QueryCollectionPrivilegeInfosAsync', query);
}

export function queryDocumentPrivilegeInfosAsync(query: DocumentPrivilegesQuery): Promise<DocumentPrivileges> {
	return ApiRequestAsync<DocumentPrivileges>('IDocumentManagementApi', 'QueryDocumentPrivilegeInfosAsync', query);
}

export function queryUnassignedCollectionPrivilegeInfosAsync(query: CollectionPrivilegesQuery): Promise<CollectionPrivileges> {
	return ApiRequestAsync<CollectionPrivileges>('IDocumentManagementApi', 'QueryUnassignedCollectionPrivilegeInfosAsync', query);
}

export function queryUnassignedDocumentPrivilegeInfosAsync(query: DocumentPrivilegesQuery): Promise<DocumentPrivileges> {
	return ApiRequestAsync<DocumentPrivileges>('IDocumentManagementApi', 'QueryUnassignedDocumentPrivilegeInfosAsync', query);
}

export function getImplicitCollectionPrivilegesAsync(query: ImplicitCollectionPrivilegesQuery): Promise<CollectionPrivileges> {
	return ApiRequestAsync<CollectionPrivileges>('IDocumentManagementApi', 'GetImplicitCollectionPrivilegesAsync', query);
}

export function getImplicitDocumentPrivilegesAsync(query: ImplicitDocumentPrivilegesQuery): Promise<DocumentPrivileges> {
	return ApiRequestAsync<DocumentPrivileges>('IDocumentManagementApi', 'GetImplicitDocumentPrivilegesAsync', query);
}


export function getRootCollectionsAsync(): Promise<CollectionInfo[]> {
	return ApiRequestAsync<CollectionInfo[]>('IDocumentManagementApi', 'GetRootCollectionsAsync');
}



import { observable, IObservableArray } from "mobx";


export class DocumentDetailsQuery {
	guid: string = "";
	language: string = "";
}

export class DocumentInfo {
	@observable guid: string = "";
	@observable name: string = "";
	@observable lastModified: Date;
}

export class DocumentDetails {
	@observable guid: string = "";
	@observable lastModified: Date;
	@observable id: InputText = new InputText();
	@observable name: InputText = new InputText();
	files: IObservableArray<FileDetails> = observable.array([]);
	metas: IObservableArray<DocumentMeta> = observable.array([]);
	@observable privileges: DocumentPrivileges = new DocumentPrivileges();
	hierarchy: IObservableArray<HierarchyValue> = observable.array([]);
	@observable isNew: boolean;
	@observable isValid: boolean;
	@observable validationMessage: string = "";
}

export class NewDocumentMetasQuery {
	metaIds: string[] = [];
	language: string = "";
}

export class DocumentMeta {
	@observable metaGuid: string = "";
	@observable caption: string = "";
	@observable multiple: boolean;
	@observable required: boolean;
	@observable languageDependent: boolean;
	@observable regex: string = "";
	@observable inputType: InputType;
	values: IObservableArray<DocumentMetaValue> = observable.array([]);
}

export class FileDetails {
	@observable guid: string = "";
	@observable language: string = "";
	@observable region: string = "";
	@observable languageName: string = "";
	@observable mimeType: string = "";
	@observable size: number;
	@observable name: InputText = new InputText();
	@observable originalName: string = "";
	@observable created: string = "";
	@observable lastModified: Date;
	@observable validFrom: InputDate = new InputDate();
	@observable validUntil: InputDate = new InputDate();
	@observable isActive: boolean;
	@observable isValid: boolean;
	@observable validationMessage: string = "";
}

export class FileDetailsUpdate {
	guid: string = "";
	language: string = "";
	mimeType: string = "";
	size: number;
	name: string = "";
	originalName: string = "";
	validFrom: Date;
	validUntil: Date;
	created: Date;
	lastModified: Date;
}

export class DocumentMetaValue {
	@observable guid: string = "";
	@observable valueNumber: InputNumber = new InputNumber();
	@observable valueDate: InputDate = new InputDate();
	@observable valueText: InputText = new InputText();
	@observable valueChoice: InputChoice = new InputChoice();
	@observable valueHierarchy: InputHierarchy = new InputHierarchy();
	@observable valueDocumentLink: InputDocumentLink = new InputDocumentLink();
	@observable lastModified: Date;
	@observable isValid: boolean;
	@observable validationMessage: string = "";
}

export class DocumentMetaUpdate {
	guid: string = "";
	metaId: string = "";
	value: string = "";
	valueNeedsTranslation: boolean;
	untranslatedValue: string = "";
	lastModified: Date;
}

export class DocumentDetailsUpdate {
	guid: string = "";
	language: string = "";
	id: string = "";
	name: string = "";
	collectionId: string = "";
	metas: DocumentMetaUpdate[] = [];
	privileges: DocumentPrivileges = new DocumentPrivileges();
	lastModified: Date;
}

export class DocumentFiles {
	files: FileDetails[] = [];
	isValid: boolean;
	validationMessage: string = "";
}

export class DocumentFilesUpdate {
	guid: string = "";
	files: FileDetailsUpdate[] = [];
}

export class CollectionHierarchy {
	parentGuids: IObservableArray<string> = observable.array([]);
	childGuids: IObservableArray<string> = observable.array([]);
}

export class CollectionInfo {
	@observable guid: string = "";
	@observable lastModified: Date;
	@observable name: string = "";
	@observable parentId: string = "";
	@observable hasSubCollections: boolean;
	subCollections: IObservableArray<CollectionInfo> = observable.array([]);
	@observable isExpanded: boolean;
}

export class CollectionDetails {
	@observable guid: string = "";
	@observable name: InputText = new InputText();
	@observable id: InputText = new InputText();
	@observable parentId: string = "";
	@observable privileges: CollectionPrivileges = new CollectionPrivileges();
	@observable lastModified: Date;
	@observable isValid: boolean;
	@observable validationMessage: string = "";
	@observable isNew: boolean;
}

export class CollectionDetailsUpdate {
	guid: string = "";
	name: string = "";
	id: string = "";
	parentId: string = "";
	privileges: CollectionPrivileges = new CollectionPrivileges();
	lastModified: Date;
}

export class CollectionContentUpdate {
	guid: string = "";
	content: string[] = [];
}

export class PrivilegesForGroup {
	guid: string = "";
	groupId: string = "";
	groupName: string = "";
	lastModified: Date;
	privilegeMemberships: PrivilegeMembership[] = [];
}

export class CollectionPrivileges {
	@observable collectionId: string = "";
	privilegesForGroups: IObservableArray<PrivilegesForGroup> = observable.array([]);
}

export class DocumentPrivileges {
	@observable documentId: string = "";
	privilegesForGroups: IObservableArray<PrivilegesForGroup> = observable.array([]);
}

export class CollectionsQuery {
	searchTerm: string = "";
	currentResult: string = "";
}

export class CollectionDocumentQuery {
	collectionId: string = "";
	name: string = "";
}

export class CollectionPrivilegesQuery {
	collectionId: string = "";
	searchTerm: string = "";
}

export class DocumentPrivilegesQuery {
	documentId: string = "";
	collectionId: string = "";
	searchTerm: string = "";
}

export class ImplicitCollectionPrivilegesQuery {
	parentCollectionId: string = "";
	privileges: CollectionPrivileges = new CollectionPrivileges();
}

export class ImplicitDocumentPrivilegesQuery {
	collectionId: string = "";
	privileges: DocumentPrivileges = new DocumentPrivileges();
}

export class InputHierarchy {
	@observable value: string = "";
	@observable isValid: boolean;
	@observable validationMessage: string = "";
}

export class HierarchyValue {
	@observable value: string = "";
	children: IObservableArray<HierarchyValue> = observable.array([]);
}

export class InputDocumentLink {
	@observable value: string = "";
	@observable isValid: boolean;
	@observable validationMessage: string = "";
	@observable collectionId: string = "";
}


export enum DocumentMode {
	Create = 2,
	CreateNew = 1,
}


export function _ignoreCompilerError_TS6133(x: any): boolean {
	return (x instanceof InputText) ||
		(x instanceof InputBoolean) ||
		(x instanceof InputChoice) ||
		(x instanceof InputDate) ||
		(x instanceof InputFile) ||
		(x instanceof PrivilegeMembership) ||
		(x instanceof FileNote) ||
		(x instanceof LanguageInfo) ||
		(x instanceof RemoveQuery);
}

